import Axios from "axios";

export default function EditViewStdBasicInfo(counsellingYear,selectedType,selectedEntrance){
    //console.log(counsellingYear,selectedType,selectedEntrance,selectedRound);
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a:'editViewBasicInfo',
            counsellingYear,
            selectedType,
            selectedEntrance
           }
    });
    return response;
}